// src/features/ownerAdmin/CreatorAuditPage.tsx
import { useState } from 'react';
import { useCreatorAuditLogs } from './useCreatorData';
import { summarize } from '../logs/summarize';
import { formatRelative, formatExactDateTime } from '../../lib/formatTime';
import './OwnerAdminPage.css';

export function CreatorAuditPage() {
  const [offset, setOffset] = useState(0);
  const limit = 20;
  const { data, isLoading, error } = useCreatorAuditLogs(offset, limit);

  const total = data?.total ?? 0;
  const hasNext = offset + limit < total;
  const hasPrev = offset > 0;

  return (
    <>
      <div className="page-header">
        <p className="page-header__eyebrow">Immutable — bot owner only</p>
        <h1 className="page-header__title">Creator Actions</h1>
      </div>

      <article className="card">
        <div className="card__content">
          <p style={{ color: 'var(--text-muted)', fontSize: 12, margin: '0 0 0.75rem' }}>
            A permanent record of the creator&apos;s own log-management actions — cannot be edited or
            cleared from this dashboard, even by the creator.
          </p>
          {isLoading && <p style={{ color: 'var(--text-muted)', fontSize: 13 }}>Loading…</p>}
          {error && <p style={{ color: 'var(--negative)', fontSize: 13 }}>Couldn&apos;t load creator logs.</p>}
          {data?.entries.length === 0 && <p style={{ color: 'var(--text-muted)', fontSize: 13 }}>No creator actions recorded yet.</p>}

          {data && data.entries.length > 0 && (
            <>
              <table className="owner-admin-table">
                <thead><tr><th>When</th><th>Action</th><th>Details</th></tr></thead>
                <tbody>
                  {data.entries.map((entry, index) => (
                    <tr key={entry.id} className={index % 2 === 1 ? 'zebra-row--even' : undefined}>
                      <td className="owner-admin-table__mono">
                        {formatRelative(entry.created_at)}
                        <span style={{ opacity: 0.7, fontSize: 11 }}> · {formatExactDateTime(entry.created_at)}</span>
                      </td>
                      <td>{summarize({ action_type: entry.action_type, target_id: entry.target_id, before_value: null, after_value: null })}</td>
                      <td className="owner-admin-table__mono" style={{ fontSize: 11 }}>
                        {entry.target_guild_id ? `Server: ${entry.target_guild_id}` : '—'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="logs-pagination">
                <button className="button-secondary" onClick={() => setOffset(Math.max(0, offset - limit))} disabled={!hasPrev}>Newer</button>
                <span className="logs-pagination__label">{offset + 1}–{Math.min(offset + limit, total)} of {total}</span>
                <button className="button-secondary" onClick={() => setOffset(offset + limit)} disabled={!hasNext}>Older</button>
              </div>
            </>
          )}
        </div>
      </article>
    </>
  );
}
